import type { FC } from 'react'
import { useId } from 'react'

import { InputNumber as AntInputNumber, Button, Space } from 'antd'
import type { InputNumberProps } from 'antd/lib/input-number'

import { Label } from 'common/components/Label/Label'

import './inputNumber.css'
import { Icon } from '@iconify/react'
import classNames from 'classnames'
import styles from './inputNumber.module.scss'
interface IProps extends InputNumberProps {
  label?: string
  visible?: boolean
  hasIncrement?: boolean
  hasDecrement?: boolean
  incrementStep?: number
  decrementStep?: number
}

export const InputNumber: FC<IProps> = ({
  disabled,
  visible,
  label,
  onChange,
  value,
  max = Number.MAX_SAFE_INTEGER,
  min = 0,
  hasDecrement = true,
  hasIncrement = true,
  incrementStep = 1,
  decrementStep = 1,
  ...rest
}) => {
  const id = useId()

  const roundToDecimalPlaces = (num: number, decimalPlaces: number = 10): number => {
    return Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
  }

  return (
    <div>
      <Label label={label} id={id} />
      <Space.Compact>
        {hasDecrement && (
          <Button
            disabled={disabled || value === min}
            onClick={() => {
              const currentValue = value ?? 0
              const newValue = roundToDecimalPlaces(Number(currentValue) - decrementStep)
              onChange?.(Math.max(min as number, newValue))
            }}>
            <Icon icon='ph:minus' />
          </Button>
        )}
        <AntInputNumber
          min={min}
          id={id}
          max={max}
          value={value}
          controls={false}
          disabled={disabled}
          className={classNames(styles.numberInput, visible ? 'input-number-disabled' : '')}
          onChange={onChange}
          {...rest}
        />
        {hasIncrement && (
          <Button
            disabled={disabled || value === max}
            onClick={() => {
              const currentValue = value ?? 0
              const newValue = roundToDecimalPlaces(Number(currentValue) + incrementStep)
              onChange?.(Math.min(max as number, newValue))
            }}>
            <Icon icon='ph:plus' />
          </Button>
        )}
      </Space.Compact>
    </div>
  )
}
